import { useEffect } from 'react';
import { recallWebSocketService } from '../services/recallWebSocketService';
import { standaloneWatchSocket } from '../services/standaloneWatchSocket';
import { restoreSessionHistory } from '../services/liveSessionData';

/**
 * After every reconnect of the call's own socket (the recall relay for a bot
 * call, `/ws/desktop` for a watched desktop call), load what was said and
 * raised while it was down from the saved session, as silent history. Nothing
 * is replayed live (owner rule: no retrospective alerts), so this is the only
 * way a gap fills in. The room is the session id in both modes.
 */
export function useRestoreHistoryOnReconnect(): void {
  useEffect(() => {
    const restoreAfterReconnect = (sessionId: string) => {
      restoreSessionHistory(sessionId).catch((error) =>
        console.warn('[useRestoreHistoryOnReconnect] History restore failed:', error)
      );
    };
    const unsubscribeRecall = recallWebSocketService.onReconnected(restoreAfterReconnect);
    const unsubscribeStandalone = standaloneWatchSocket.onReconnected(restoreAfterReconnect);
    return () => {
      unsubscribeRecall();
      unsubscribeStandalone();
    };
  }, []);
}
